let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8A1qx")).then(() => parcelRequire('b6g33'));